import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { signInWithGoogle, GOOGLE_CLIENT_ID } from '../lib/auth';
import { useAuth } from '../hooks/useAuth';

export default function Login() {
  const { user, refresh } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const handleSignIn = async () => {
    setLoading(true);
    setError(null);
    try {
      await signInWithGoogle(GOOGLE_CLIENT_ID);
      refresh();
    } catch (err) {
      const msg = err instanceof Error ? err.message : 'Přihlášení selhalo';
      setError(msg);
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-teal-dark to-teal">
      <div className="card w-full max-w-md p-10 text-center">
        <div className="mb-8">
          <img src="/bd-color.svg" alt="BuyDubai" className="mx-auto mb-6 h-10 w-auto" />
          <div className="mb-2 font-heading text-xl font-semibold text-dark">Interní wiki</div>
          <p className="text-sm text-gray-600">
            Dokumentace firemních procesů. Přihlášení přes Google Workspace účet{' '}
            <span className="font-semibold text-teal">@buydubai.eu</span>.
          </p>
        </div>

        <button onClick={handleSignIn} disabled={loading} className="btn-primary w-full justify-center">
          {loading ? 'Otevírám Google…' : 'Přihlásit se přes Google'}
        </button>

        {error && (
          <div className="mt-4 rounded-md border border-danger/40 bg-danger/10 p-3 text-sm text-danger">
            {error}
          </div>
        )}

        <p className="mt-8 text-xs text-gray-500">
          Pokud se ti nepovede přihlásit, kontaktuj admina v kanceláři.
        </p>
      </div>
    </div>
  );
}
